import React, { useState, useEffect, useCallback } from "react";
import StarRating from "./StarRating";
import axios from "axios";

const Rating = ({
  userId,
  productId = "999",
  onClick,
  refreshTrigger,
  emailId,
}) => {
  const [feedbackData, setFeedbackData] = useState({ rating: 0, feedback: "" });

  const fetchFeedbackData = useCallback(async () => {
    try {
      const response = await axios.get(
        "https://auth.ssccglpinnacle.com/api/v1/typing/get-feedback",
        { params: { userId, productId } }
      );

      if (response.data) {
        setFeedbackData({
          rating: response.data.rating,
          feedback: response.data.feedback,
        });
      }
    } catch (error) {
      console.error("Error fetching feedback:", error);
      setFeedbackData({ rating: 0, feedback: "" });
    }
  }, [userId, productId, refreshTrigger, emailId]);

  useEffect(() => {
    fetchFeedbackData();
  }, [fetchFeedbackData]);

  return (
    <div onClick={onClick} className="cursor-pointer w-fit mx-auto">
      <StarRating filledStars={feedbackData.rating} />
    </div>
  );
};

export default Rating;
